import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreUsersByIdPasswordPatchAsyncSlice } from './patch';

export const coreUsersByIdPasswordReducers = combineReducers({
	patch: coreUsersByIdPasswordPatchAsyncSlice.asyncReducers
});

export const coreUsersByIdPasswordWatchers = combineAllWatchers([ coreUsersByIdPasswordPatchAsyncSlice.asyncWatchers ]);
